import type { MaterialState } from './material.types';

import type { RootState } from '~/redux/store';

export const selectRestorableMaterial = ({
  material,
}: RootState): MaterialState['restorableMaterial'] =>
  material.restorableMaterial;

export const selectSelectedMaterial = ({
  material,
}: RootState): MaterialState['selectedMaterial'] => material.selectedMaterial;
